'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import { TIME_SERIES } from 'reporting-data/constants/configTypes';
import { Directions, Order } from 'reporting-visualizations/field/order';

// see https://git.hubteam.com/HubSpot/reporting/blob/9eeebbf437a3d07cc84d95bdff4a0e37dc99e267/reporting-ui-components/static-2.58219/js/reports/decorators/SeriesOptionsDecorator/series.js#L11
const layerOrdering = (layer, seriesOrder, dimensionCount, isTimeSeries) => {
  //1 dimension and ordered by specific dimension keys
  if (!isTimeSeries && dimensionCount === 1 && seriesOrder.get('type') === 'static' && !layer.getIn(['color', 'field'])) {
    return layer.setIn(['x', 'order'], Order({
      field: layer.getIn(['y', 'field']),
      defined: seriesOrder.get('values', List()),
      direction: Directions.descending
    }));
  }

  // 2 dimensions and ordered by direction
  if (dimensionCount === 2 && seriesOrder.get('type') === 'ranked' && layer.getIn(['color', 'field'])) {
    return layer.setIn(['color', 'order'], Order({
      field: layer.getIn(['y', 'field']),
      direction: seriesOrder.get('direction') === 'asc' ? Directions.ascending : Directions.descending
    }));
  }

  // 2 dimension and ordered by specific dimension keys
  if (dimensionCount === 2 && seriesOrder.get('type') === 'static' && layer.getIn(['color', 'field'])) {
    return layer.setIn(['color', 'order'], Order({
      field: layer.getIn(['y', 'field']),
      defined: seriesOrder.get('values', List())
    }));
  }
  return layer;
};
export const applySeriesOrder = (visualization, report) => {
  const dimensionCount = (report.getIn(['config', 'dimensions']) || List()).count();
  const isTimeSeries = report.getIn(['config', 'configType']) === TIME_SERIES;
  const seriesOrder = report.getIn(['displayParams', 'seriesOrder'], ImmutableMap());
  return visualization.update('layers', (layers = List()) => layers.map(layer => layer.update(updateLayer => layerOrdering(updateLayer, seriesOrder, dimensionCount, isTimeSeries))));
};